import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private currentUserService: CurrentUserService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.currentUserService.isNoAccess || this.currentUserService.isUser) {
      this.router.navigate(['/no-access']);
      return false;
    } else if (state.url === '/') {
      const accountId = this.currentUserService.currentUser.accountId;
      if (accountId) {
        this.router.navigate(['accounts', accountId, 'details']);
      }
      return false;
    }
    return true;
  }
}
